import React from "react"
import { Link } from "gatsby"
import styled from "styled-components"
import { useTranslation } from "react-i18next"

const languageName = {
  en: "English",
  sc: "中文",
}

const LanguageButton = styled(Link)`
  font-size: 12px;
  line-height: 14px;
  color: white;
  text-decoration: none;
  margin: 7px;
  padding: 6px 15px;
  font-weight: 400;
  background: var(--ud-green);
  position: absolute;
  border-radius: 20px;
  right: 85px;
  top: 0;
`

const Language = (props) => {
  const { i18n } = useTranslation()
  // const currentDir = props.location.pathname.split('/');
  // const removed = currentDir.splice(2); // remove the first two value which is language
  const lang = i18n.language === "en" ? "sc" : "en";
  // const targetDir = removed.length > 0 ? `/${lang}/${removed.join('/')}${props.location.search}` : `/${lang}/`;
  const targetDir = `/${lang}/`;

  return (
    <div>
      <LanguageButton to={`${targetDir}`}>
        {i18n.language === "en" ? languageName["sc"] : languageName["en"]}
      </LanguageButton>
    </div>
  )
}

export default Language
